import { render } from "./ProductsAccordingToModuleEntered.vue?vue&type=template&id=1e778c82"
import script from "./ProductsAccordingToModuleEntered.vue?vue&type=script&lang=js"
export * from "./ProductsAccordingToModuleEntered.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__